const doshaQuestions = {
  physical: {
    title: "Physical Characteristics",
    subtitle: "Tell us about your natural physical traits",
    questions: [
      {
        id: 'body_build',
        question: 'Which best describes your natural body build?',
        type: 'single_choice',
        options: [
          { text: 'Thin, light frame, hard to gain weight', vata: 3, pitta: 0, kapha: 0 },
          { text: 'Medium build, moderate weight', vata: 0, pitta: 3, kapha: 0 },
          { text: 'Larger frame, easy to gain weight', vata: 0, pitta: 0, kapha: 3 }
        ]
      },
      {
        id: 'skin_type',
        question: 'How would you describe your skin?',
        type: 'single_choice',
        options: [
          { text: 'Dry, rough, thin, cool to touch', vata: 3, pitta: 0, kapha: 0 },
          { text: 'Warm, oily, prone to irritation/rashes', vata: 0, pitta: 3, kapha: 0 },
          { text: 'Thick, oily, smooth, cool and pale', vata: 0, pitta: 0, kapha: 3 }
        ]
      },
      {
        id: 'hair_texture',
        question: 'What is your natural hair texture and quality?',
        type: 'single_choice',
        options: [
          { text: 'Dry, brittle, frizzy, thin', vata: 3, pitta: 0, kapha: 0 },
          { text: 'Fine, straight, oily, prone to early graying', vata: 0, pitta: 3, kapha: 0 },
          { text: 'Thick, wavy, lustrous, strong', vata: 0, pitta: 0, kapha: 3 }
        ]
      },
      {
        id: 'eyes',
        question: 'Which best describes your eyes?',
        type: 'single_choice',
        options: [
          { text: 'Small, dry, active, black/brown', vata: 3, pitta: 0, kapha: 0 },
          { text: 'Sharp, bright, gray/green/hazel', vata: 0, pitta: 3, kapha: 0 },
          { text: 'Large, calm, blue/brown', vata: 0, pitta: 0, kapha: 3 }
        ]
      },
      {
        id: 'weight_tendency',
        question: 'What is your relationship with weight?',
        type: 'single_choice',
        options: [
          { text: 'Hard to gain weight, lose weight easily', vata: 3, pitta: 0, kapha: 0 },
          { text: 'Moderate weight, can gain or lose with effort', vata: 0, pitta: 3, kapha: 0 },
          { text: 'Gain weight easily, hard to lose weight', vata: 0, pitta: 0, kapha: 3 }
        ]
      }
    ]
  },
  mental: {
    title: "Mental & Emotional Traits",
    subtitle: "Help us understand your mental patterns and emotional tendencies",
    questions: [
      {
        id: 'personality',
        question: 'Which personality traits resonate most with you?',
        type: 'single_choice',
        options: [
          { text: 'Creative, energetic, enthusiastic, changeable', vata: 3, pitta: 0, kapha: 0 },
          { text: 'Focused, competitive, determined, intense', vata: 0, pitta: 3, kapha: 0 },
          { text: 'Calm, steady, loyal, patient', vata: 0, pitta: 0, kapha: 3 }
        ]
      },
      {
        id: 'stress_response',
        question: 'How do you typically respond to stress?',
        type: 'single_choice',
        options: [
          { text: 'Worry, anxiety, become scattered', vata: 3, pitta: 0, kapha: 0 },
          { text: 'Anger, irritability, become critical', vata: 0, pitta: 3, kapha: 0 },
          { text: 'Withdraw, become sluggish, avoid confrontation', vata: 0, pitta: 0, kapha: 3 }
        ]
      },
      {
        id: 'learning_style',
        question: 'How do you prefer to learn new information?',
        type: 'single_choice',
        options: [
          { text: 'Quick to learn, quick to forget, prefer variety', vata: 3, pitta: 0, kapha: 0 },
          { text: 'Sharp understanding, good retention, like details', vata: 0, pitta: 3, kapha: 0 },
          { text: 'Slow to learn but excellent long-term memory', vata: 0, pitta: 0, kapha: 3 }
        ]
      },
      {
        id: 'decision_making',
        question: 'How do you make decisions?',
        type: 'single_choice',
        options: [
          { text: 'Quickly but often change my mind', vata: 3, pitta: 0, kapha: 0 },
          { text: 'Decisively after analyzing options', vata: 0, pitta: 3, kapha: 0 },
          { text: 'Slowly and deliberately, rarely change', vata: 0, pitta: 0, kapha: 3 }
        ]
      },
      {
        id: 'communication',
        question: 'How would others describe your communication style?',
        type: 'single_choice',
        options: [
          { text: 'Talkative, animated, jump between topics', vata: 3, pitta: 0, kapha: 0 },
          { text: 'Clear, direct, persuasive, sometimes sharp', vata: 0, pitta: 3, kapha: 0 },
          { text: 'Thoughtful, soft-spoken, good listener', vata: 0, pitta: 0, kapha: 3 }
        ]
      }
    ]
  },
  lifestyle: {
    title: "Lifestyle Preferences",
    subtitle: "Tell us about your daily habits and preferences",
    questions: [
      {
        id: 'sleep_patterns',
        question: 'How would you describe your sleep?',
        type: 'single_choice',
        options: [
          { text: 'Light sleeper, difficulty falling asleep, 6-7 hours', vata: 3, pitta: 0, kapha: 0 },
          { text: 'Good sleeper, moderate amount, 6-8 hours', vata: 0, pitta: 3, kapha: 0 },
          { text: 'Heavy sleeper, need 8+ hours, hard to wake up', vata: 0, pitta: 0, kapha: 3 }
        ]
      },
      {
        id: 'weather_preference',
        question: 'What weather do you prefer?',
        type: 'single_choice',
        options: [
          { text: 'Warm, humid weather; dislike cold and wind', vata: 3, pitta: 0, kapha: 0 },
          { text: 'Cool weather; dislike heat and humidity', vata: 0, pitta: 3, kapha: 0 },
          { text: 'Warm, dry weather; dislike cold and damp', vata: 0, pitta: 0, kapha: 3 }
        ]
      },
      {
        id: 'exercise_preference',
        question: 'What type of exercise do you gravitate towards?',
        type: 'single_choice',
        options: [
          { text: 'Varied activities, yoga, walking, dancing', vata: 3, pitta: 0, kapha: 0 },
          { text: 'Competitive sports, running, intense workouts', vata: 0, pitta: 3, kapha: 0 },
          { text: 'Steady, consistent exercise, swimming, hiking', vata: 0, pitta: 0, kapha: 3 }
        ]
      },
      {
        id: 'daily_routine',
        question: 'How do you feel about daily routines?',
        type: 'single_choice',
        options: [
          { text: 'Prefer variety, struggle with fixed schedules', vata: 3, pitta: 0, kapha: 0 },
          { text: 'Like organized schedules, efficient routines', vata: 0, pitta: 3, kapha: 0 },
          { text: 'Thrive on consistent, steady routines', vata: 0, pitta: 0, kapha: 3 }
        ]
      },
      {
        id: 'social_energy',
        question: 'How do you recharge your energy?',
        type: 'single_choice',
        options: [
          { text: 'Need variety and stimulation, enjoy socializing', vata: 3, pitta: 0, kapha: 0 },
          { text: 'Balance of activity and rest, selective socializing', vata: 0, pitta: 3, kapha: 0 },
          { text: 'Prefer quiet, peaceful environments, close relationships', vata: 0, pitta: 0, kapha: 3 }
        ]
      }
    ]
  },
  digestive: {
    title: "Digestive Patterns",
    subtitle: "Help us understand your digestive tendencies",
    questions: [
      {
        id: 'appetite',
        question: 'How would you describe your appetite?',
        type: 'single_choice',
        options: [
          { text: 'Variable, sometimes forget to eat', vata: 3, pitta: 0, kapha: 0 },
          { text: 'Strong, regular, get irritable when hungry', vata: 0, pitta: 3, kapha: 0 },
          { text: 'Steady but can skip meals easily', vata: 0, pitta: 0, kapha: 3 }
        ]
      },
      {
        id: 'digestion_strength',
        question: 'How is your digestion?',
        type: 'single_choice',
        options: [
          { text: 'Variable, gas, bloating, constipation', vata: 3, pitta: 0, kapha: 0 },
          { text: 'Strong, quick, sometimes heartburn/acid', vata: 0, pitta: 3, kapha: 0 },
          { text: 'Slow but steady, sometimes heavy feeling', vata: 0, pitta: 0, kapha: 3 }
        ]
      },
      {
        id: 'food_preferences',
        question: 'What foods do you naturally crave?',
        type: 'single_choice',
        options: [
          { text: 'Warm, cooked, moist foods; sweet, sour, salty tastes', vata: 3, pitta: 0, kapha: 0 },
          { text: 'Cool, raw foods; sweet, bitter, astringent tastes', vata: 0, pitta: 3, kapha: 0 },
          { text: 'Light, dry foods; pungent, bitter, astringent tastes', vata: 0, pitta: 0, kapha: 3 }
        ]
      },
      {
        id: 'eating_habits',
        question: 'How do you typically eat?',
        type: 'single_choice',
        options: [
          { text: 'Quickly, irregularly, while distracted', vata: 3, pitta: 0, kapha: 0 },
          { text: 'Regularly, moderate portions, focused', vata: 0, pitta: 3, kapha: 0 },
          { text: 'Slowly, large portions, enjoy the experience', vata: 0, pitta: 0, kapha: 3 }
        ]
      },
      {
        id: 'thirst',
        question: 'How is your thirst?',
        type: 'single_choice',
        options: [
          { text: 'Variable, often forget to drink water', vata: 3, pitta: 0, kapha: 0 },
          { text: 'Strong thirst, need cool drinks', vata: 0, pitta: 3, kapha: 0 },
          { text: 'Low thirst, prefer warm drinks', vata: 0, pitta: 0, kapha: 3 }
        ]
      }
    ]
  },
  health: {
    title: "Health Tendencies",
    subtitle: "Tell us about your general health patterns",
    questions: [
      {
        id: 'energy_levels',
        question: 'How would you describe your energy levels?',
        type: 'single_choice',
        options: [
          { text: 'High energy in bursts, then crash', vata: 3, pitta: 0, kapha: 0 },
          { text: 'Consistent, strong energy throughout day', vata: 0, pitta: 3, kapha: 0 },
          { text: 'Steady energy, slow to start in morning', vata: 0, pitta: 0, kapha: 3 }
        ]
      },
      {
        id: 'common_complaints',
        question: 'Which health issues do you experience most?',
        type: 'single_choice',
        options: [
          { text: 'Anxiety, insomnia, dry skin, constipation', vata: 3, pitta: 0, kapha: 0 },
          { text: 'Heartburn, skin rashes, anger, inflammation', vata: 0, pitta: 3, kapha: 0 },
          { text: 'Weight gain, congestion, sluggishness, depression', vata: 0, pitta: 0, kapha: 3 }
        ]
      },
      {
        id: 'recovery_time',
        question: 'How quickly do you recover from illness?',
        type: 'single_choice',
        options: [
          { text: 'Slow recovery, tend to relapse', vata: 3, pitta: 0, kapha: 0 },
          { text: 'Moderate recovery with proper care', vata: 0, pitta: 3, kapha: 0 },
          { text: 'Good immunity, steady recovery', vata: 0, pitta: 0, kapha: 3 }
        ]
      },
      {
        id: 'temperature_regulation',
        question: 'How do you handle temperature changes?',
        type: 'single_choice',
        options: [
          { text: 'Always feel cold, poor circulation', vata: 3, pitta: 0, kapha: 0 },
          { text: 'Often feel warm, good circulation', vata: 0, pitta: 3, kapha: 0 },
          { text: 'Good tolerance, rarely feel extreme temps', vata: 0, pitta: 0, kapha: 3 }
        ]
      },
      {
        id: 'seasonal_changes',
        question: 'Which season affects you most negatively?',
        type: 'single_choice',
        options: [
          { text: 'Fall/Early Winter (cold, dry, windy)', vata: 3, pitta: 0, kapha: 0 },
          { text: 'Summer (hot, humid, intense)', vata: 0, pitta: 3, kapha: 0 },
          { text: 'Late Winter/Spring (cold, wet, heavy)', vata: 0, pitta: 0, kapha: 3 }
        ]
      }
    ]
  }
};

export default doshaQuestions;
